module.exports = __webpack_public_path__ + "static/media/IMG_2107-min.7d755ce9.jpg";